import { EventBus } from "OK/EventBus";

const create = EventBus.factory('banner.events');

export const ACTIVATE_MONEY_SAVE = create('activateMoneySave');
